import { useQuery } from '@tanstack/react-query';
import { resultsApi } from '../api/results.api';

export const resultsQueryKey = (fhirId: string | null) => ['results', fhirId] as const;

/** A patient's medical results / consultations (newest first). */
export function useResults(patientFhirId: string | null) {
  return useQuery({
    queryKey: resultsQueryKey(patientFhirId),
    queryFn: () => resultsApi.getResults(patientFhirId!),
    enabled: Boolean(patientFhirId),
    staleTime: 60_000,
  });
}
